import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITENS.SET_FILTRO_LISTAGEM](state, filtro) {
		state.filtro = filtro
	},

	[mutationTypes.ITENS.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.ITENS.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
}
